type QuestionOptionsProps = {
  options: string[]
  selectedOption: number | undefined
  onclick: (index: number) => void
}

export function QuestionOptions({
  options,
  selectedOption,
  onclick
}: QuestionOptionsProps): JSX.Element {
  return (
    <div className="options-container">
      {options.map((option: string, idx: number) => (
        <div
          key={idx}
          className={`option-text-container ${selectedOption === idx ? 'selected' : ''}`}
          onClick={() => onclick(idx)}
        >
          <span className="option-text">{option}</span>
        </div>
      ))}
    </div>
  )
}
